module.exports = __webpack_public_path__ + "img/kristen-anderson.jpg?8f6efc26be0a7c71e7a8c28afb94bda2";